<template>
  <div class="page-ganhadores">
    <h1 class="page-title" v-html="$config.strings['winners-title']"/>
    <div class="page-description" v-html="$config.strings['winners-description']"/>

      <div v-if="filters.length > 0" class="filter-block">

        <select @change="onYearChange" id='yearSelector' v-bind:value="yearBindValue" class='date-filter'>
          <option value='' selected >Ano</option>
          <option v-for="(date, index) in filters" v-bind:key="date.year" v-bind:value="index" v-html="date.year" />
        </select>

        <select @change="onMonthChange" class='date-filter' v-if="!!selectedYear" v-bind:value='monthBindValue' >
          <option value='' selected >Mês</option>
          <option
            v-for="month in selectedYear.months"
            v-bind:key="`${month}/${selectedYear.year}`"
            v-bind:value='`${month}/${selectedYear.year}`'
            v-html='monthNames[Number(month) - 1]'
          />
        </select>

        <a v-if="filterApplied" class='date-filter reset-btn' @click="resetFilter">Limpar Filtro</a>

      </div>

    <template v-if="displayWinners.length > 0">
      <div class="winners-count" v-html="`${displayWinners.length} ganhadores em ${selectedDate}`" />
      <div class="sorteio-tables-container">
        <table class="sorteio-table">
          <tr class="sorteio-table-header">
            <td class="sorteio-table-col" v-html="$config.strings['winners-table-columnName-1']"/>
            <td class="sorteio-table-col" v-html="$config.strings['winners-table-columnName-2']"/>
            <td class="sorteio-table-col" v-html="$config.strings['winners-table-columnName-3']"/>
            <td class="sorteio-table-col" v-html="$config.strings['winners-table-columnName-4']"/>
          </tr>
          <tr class="sorteio-table-row" :key="JSON.stringify(ganhador)" v-for="ganhador in displayWinners">
            <td class="sorteio-table-col" v-html="ganhador.numeroSorte"/>
            <td class="sorteio-table-col" v-html="ganhador.nome"/>
            <td class="sorteio-table-col" v-html="ganhador.descricao"/>
            <td class="sorteio-table-col" v-html="ganhador.loja"/>
          </tr>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="empty-state">
        <h3>Não encontramos nada...</h3>
        <h4>Para conferir ao que está concorrendo, consulte seu número da sorte <a class="goTo-luckNumber-btn" @click="$router.push('/numero-da-sorte')">clicando aqui</a>!</h4>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _find from 'lodash/find'
import _filter from 'lodash/filter'
import _map from 'lodash/map'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'page-ganhadores',
  data () {
    return {
      filters: [],
      displayWinners: [],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      selectedYear: undefined,
      selectedDate: 'todos os sorteios',
      filterApplied: false,
      monthBindValue: '',
      yearBindValue: ''
    }
  },
  computed: {
    ...mapState({
      ganhadores: state => state.ganhadores
    })
  },
  methods: {
    ...mapActions(['getGanhadores']),
    getFiltersFromData () {
      let datesFound = this.filters

      for (let i = 0; i < this.ganhadores.length; i++) {
        const data = (this.ganhadores[i].data.split(' ')[0]).split('/')
        const year = data[2]
        const month = data[1]
        const yearPkg = _find(datesFound, (data) => data.year === year)

        if (!yearPkg) {
          datesFound.push({ year: year, months: [month] })
        } else {
          !_find(yearPkg.months, (item) => item === month) && yearPkg.months.push(month)
        }
      }

      this.filters = _sortBy(
        _map(
          datesFound,
          (date) => ({
            year: date.year,
            months: _sortBy(date.months, (month) => Number(month)).reverse()
          })
        ),
        (item) => item.year
      ).reverse()
    },
    doFilter (target) {
      if (!target) {
        this.displayWinners = this.ganhadores
        return void null
      }

      this.displayWinners = _filter(this.ganhadores, (winner) => {
        const data = winner.data.split(' ')[0]
        const regex = new RegExp(target, 'gi')
        return regex.test(data)
      })
      this.selectedDate = `${this.monthNames[Number(target.split('/')[0]) - 1]} de ${target.split('/')[1]}`
      this.filterApplied = true
    },
    resetFilter () {
      this.displayWinners = this.ganhadores
      this.selectedYear = undefined
      this.selectedDate = 'todos os sorteios'
      this.filterApplied = false
      this.yearBindValue = ''
      this.monthBindValue = ''
    },
    setInicialState () {
      const lastWinnerDate = this.filters[0]
      this.selectedYear = lastWinnerDate
      this.yearBindValue = 0
      this.monthBindValue = `${lastWinnerDate.months[0]}/${lastWinnerDate.year}`
      this.doFilter(`${lastWinnerDate.months[0]}/${lastWinnerDate.year}`)
    },
    onYearChange ({ target: { value: targetIndex } }) {
      if (!targetIndex) {
        this.resetFilter()
        return void null
      }

      this.selectedYear = this.filters[targetIndex]
      this.yearBindValue = targetIndex
    },
    onMonthChange ({ target: { value: dateTarget } }) {
      if (!dateTarget) return void null
      this.doFilter(dateTarget)
      this.monthBindValue = dateTarget
    }
  },
  mounted () {
    this.getGanhadores().finally(() => {
      this.ganhadores = _sortBy(this.ganhadores, ({ data }) => data).reverse()
      this.displayWinners = this.ganhadores
      this.getFiltersFromData()
      this.setInicialState()
    })
  }
}
</script>

<style lang="scss" scoped>

.page-ganhadores {
  @include container-element;
  background-color: var(--secondary-light);

  .empty-state {
    padding-top: 10%;
    color: var(--on-background);
    text-align: center;

    .goTo-luckNumber-btn {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .ganhadores-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .filter-block {
    display: flex;
    flex-flow: row nowrap;
    overflow-x: auto;
    position: relative;

    .date-filter {
      background-color: var(--secondary);
      min-height: 50px;
      color: var(--on-secondary);
      border-radius: 8px;
      font-size: 18px;
      font-weight: 600;
      padding: 12.5px 35px 12.5px 12.5px;
      margin-right: 15px;
      border: none;
      appearance: none;
      -webkit-appearance: none;
      position: relative;
      display: block;
      background-image: url('~@/assets/expand-arrow.png');
      background-position: 95% 55%;
      background-repeat: no-repeat;
      background-size: 20px;

      @include  for-size(phone-only) {
        font-size: 14px;
        font-weight: 500;
        padding: 7.5px 30px 7.5px 7.5px;
        margin-right: 7px;
        min-height: 35px;
      }

      &.reset-btn {
        cursor: pointer;
        padding: 12px;
        background-image: initial;
        white-space: nowrap;

        @include for-size(phone-only) {
          padding: 7.5px;
        }
      }

      > option {
        font-weight: 600;
      }
    }
}

  .winners-count {
    padding: 25px 0 15px 0;
  }

  .sorteio-tables-container {
    overflow-x: auto;

    @include for-size(phone-only) {
      padding: 0 15px;
      margin-left: -15px;
      margin-right: -15px;
      font-size: 15px;
    }

    .sorteio-table {
      border-color: gray;
      .sorteio-table-header {
        background-color: var(--primary);
        color: var(--on-primary);
        & > * {
          color: inherit;
        }
      }
      color: var(--on-primary);
      margin-bottom: 50px;
      min-width: 600px;
      border-color: var(--secondary-light);
      width: 100%;
      border: none;
      border-radius: 10px;
      overflow: hidden;

      .sorteio-table-row {
        background-color: var(--surface);
        color: var(--on-surface);

        &:nth-child(odd) {
          background-color: var(--surface-dark);
          color: var(--on-surface-dark);
        }
      }

      .sorteio-table-col {
        padding: 30px;
        @include for-size(phone-only) {
          padding: 15px;
        }
    }
    }
  }
}
</style>
